import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Wrench, Truck, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import SectionHeading from "@/components/SectionHeading";

export default function WhoWeAreSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-white section-padding px-4 sm:px-6 lg:px-8">
      <div className="content-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-gold/10 rounded-3xl -z-10" />
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-secondary-blue/10 rounded-3xl -z-10" />
            <img src="/images/workshop.jpg" alt="Sky Mark Co." className="w-full rounded-2xl aspect-[4/3] object-cover shadow-xl" loading="lazy" />
            <div className="absolute -bottom-4 -right-2 md:right-4 bg-white rounded-xl p-4 shadow-lg border border-muted-border">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-deep flex items-center justify-center">
                  <ShieldCheck className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="font-display font-bold text-sm text-graphite">{t("projectReady")}</p>
                  <p className="text-xs text-steel">{t("boqDrawing")}</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }}>
            <SectionHeading overlineKey="aboutOverline" titleKey="aboutTitle" align="left" />
            <p className="mt-5 text-steel leading-relaxed">{t("aboutP1")}</p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-3 p-4 bg-steel-light rounded-xl">
                <div className="w-9 h-9 rounded-lg bg-primary-deep/10 flex items-center justify-center shrink-0">
                  <Truck className="w-4 h-4 text-primary-deep" />
                </div>
                <div>
                  <p className="font-medium text-sm text-graphite">{t("industrialSupply")}</p>
                  <p className="text-xs text-steel mt-0.5">{t("industrialSupplyShort")}</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-steel-light rounded-xl">
                <div className="w-9 h-9 rounded-lg bg-primary-deep/10 flex items-center justify-center shrink-0">
                  <Wrench className="w-4 h-4 text-primary-deep" />
                </div>
                <div>
                  <p className="font-medium text-sm text-graphite">{t("cncFab")}</p>
                  <p className="text-xs text-steel mt-0.5">{t("cncFabShort")}</p>
                </div>
              </div>
            </div>

            <Link to="/about" className="btn-secondary mt-6">
              {t("learnMore")}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
